import Enums from "../../../enums/enums";
const state = {
  getPeakGuide: null,
  updatePeakGuideLoadingStatus: Enums.LoadingStatusType.None,
  getPeakGuideLoadingStatus: Enums.LoadingStatusType.None,
  showPeakGuide: false,
};

const getters = {
  GetPeakGuide: (state) => {
    return state.getPeakGuide;
  },
  GetUpdatePeakGuideLoadingStatus: (state) => {
    return state.updatePeakGuideLoadingStatus;
  },
  GetPeakGuideLoadingStatus: (state) => {
    return state.getPeakGuideLoadingStatus;
  },
  GetShowPeakGuide(state) {
    return state.showPeakGuide;
  },
};
export { getters, state };
